import { ApplicationState } from '@/store';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import './styles.scss';

interface OnboardingWhiteLabelNavigatorProps {
    numberDots: number;
    shownBigButton: boolean;
    onComplete: () => void;
    onNext: () => void;
    onPreview: () => void;
    finished: boolean;
    currentPageInDots: number;
}
function generatePagesArray(from: number, to: number) {
    return [...new Array(to - from)].map((_, index) => from + index + 1).filter((page) => page > 0);
}
const OnboardingWhiteLabelNavigator: React.FC<OnboardingWhiteLabelNavigatorProps> = ({
    finished,
    numberDots,
    onComplete,
    onNext,
    onPreview,
    shownBigButton,
    currentPageInDots,
}: OnboardingWhiteLabelNavigatorProps) => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const handleOnNext = useCallback(() => {
        if (finished) {
            onComplete();
            return;
        }

        onNext();
    }, [finished, onComplete, onNext]);

    return (
        <div className={`onboarding-whitelabel-navigator-container ${!shownBigButton && 'small'}`}>
            <button className={`btn btn-primary btn-block next-button ${!shownBigButton && 'small'}`} onClick={handleOnNext} type="button">
                <div className={`button-content-container ${shownBigButton && 'show'}`}>
                    <span className={`${shownBigButton && 'show'}`}>{finished ? strings.FINISH : strings.BEGIN}</span>
                </div>
                <div className={`button-content-container ${!shownBigButton && 'show'}`}>
                    <span className={`material-icons-outlined button-icon`}>arrow_right_alt</span>
                </div>
            </button>

            <div className={`navigation-container ${!shownBigButton && 'show'}`}>
                <button className={`btn btn-primary prev-button`} onClick={onPreview} type="button">
                    <span className={`material-icons-outlined button-icon`}>arrow_right_alt</span>
                </button>

                <div className="dots-container">
                    {generatePagesArray(0, numberDots).map((_, index) => (
                        <div className={`dot ${index === currentPageInDots && 'current'}`} key={`dot-${index}`} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export { OnboardingWhiteLabelNavigator };
